var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.NcDialog,{attrs:{"name":_vm.name,"message":_vm.message,"container":_vm.container,"size":_vm.size,"buttons":_vm.buttons},on:{"closing":_setup.onClosing}})
}
var staticRenderFns = []

export { render, staticRenderFns }